import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const RspResultMob = () => {
  return <CommonResult />;
};

export default RspResultMob;
